<template>
  <div>
    <div>
      <div class="topBox">
        <div class="sideList">
          <img src="../../assets/left.png" @click="linkBack()" />
        </div>
        <div class="mainList">我的经销商</div>
        <div class="sideList">
          <div class="addBtn" @click="linkToAdd()">点击新增</div>
        </div>
      </div>
      <div class="topH"></div>
    </div>
    <div class="searchBox">
      <input type="text" v-model="cName" />
      <img src="../../assets/search.png" @click="search()" />
    </div>
    <div class="searchBoxH"></div>
    <van-empty description="" v-if="list.length==0" />
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="linkList" v-for="item in list" :key="item" @click="linkToDetail(item.id)">
        <div>
          <p>经销商名称：{{item.cName}}</p>
          <p></p>
          <p>手机号：{{item.cMobile}}</p>
        </div>
        <img src="../../assets/right.png" />
      </div>
    </van-list>
    
    <transition name="slide-fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import { Button, List, Cell, Toast,Empty } from "vant";

export default {
  data() {
    return {
      msg: "我的经销商",
      list: [],
      loading: false,
      finished: false,
      num: 1,
      cName: "",
    };
  },
  components: {
    [Button.name]: Button,
    [List.name]: List,
    [Cell.name]: Cell,
    [Toast.name]: Toast,
    [Empty.name]: Empty,
  },
  methods: {
    linkBack() {
      this.$router.go(-1);
    },
    linkToAdd() {
      this.$router.push({
        path: "/customer/Addlist",
      });
    },
    linkToDetail(id) {
      this.$router.push({
        path: "/customer/Detail",
        query:{id:id}
      });
    },
    search() {
      this.list = [];
      this.loading = true;
      this.num=1;
      this.onLoad();
      
    },
    onLoad() {
      // 异步更新数据
      var _this = this;
      var dd = {
        ticket: sessionStorage.getItem("ticket"),
        page: _this.num,
        limit: 30,
        cName: _this.cName,
      };
      this.$get("/api/PhoneAPI/GetCustomerInfoList", dd)
        .then((res) => {
          _this.num=_this.num+1;
          for (var i = 0; i < res.data.length; i++) {
            this.list.push(res.data[i]);
          }
          // 加载状态结束
          this.loading = false;

          // 数据全部加载完成
          if (res.data.length == 0) {
            this.finished = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.topBox {
  width: 375px;
  height: 44px;
  background-color: #444444;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  align-content: center;
  justify-content: space-between;
}
.topH {
  height: 44px;
}
.sideList {
  width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sideList img {
  width: 18px;
  height: 18px;
  margin-right: 30px;
}
.mainList {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: white;
}
.addBtn {
  background: #e62129;
  color: white;
  border-radius: 5px;
  font-size: 10px;
  padding: 3px;
}
.searchBox {
  height: 50px;
  border-bottom: 1px solid #eee;
  display: flex;
  background: white;
  justify-content: space-around;
  align-items: center;
  padding: 0 10px;
  position: fixed;
  top: 44px;
  left: 0;
  width: 355px;
  z-index: 99;
}
.searchBox img {
  width: 28px;
  flex-shrink: 0;
  height: 28px;
  margin-left: 20px;
}
.searchBox input {
  width: 100%;
  height: 30px;
  border: none;
  box-shadow: 0 0 5px 0 #eee;
  font-size: 12px;
  text-indent: 6px;
}
.searchBoxH {
  height: 50px;
}
.linkList {
  margin: 10px;
  box-shadow: 0 0 5px 0 #eee;
  border: 1px solid #eee;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.linkList p {
  text-align: left;
  font-size: 14px;
}
.linkList img {
  width: 20px;
  height: 20px;
}
</style>
